var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailContactPicto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.7 56.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #ff5e11;\n      }\n\n      .st2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 2.8,
    y: 2.7,
    width: 51,
    height: 51.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_291",
    className: "st1",
    d: "M28.6,15.2c-1.4,0-2.8.3-4,.9-1.1.6-2.1,1.5-2.7,2.7-.7,1.2-1,2.6-1,3.9v.4c0,.2.2.4.4.4,0,0,0,0,0,0l4.3.2c.3,0,.4-.1.4-.4v-.6c0-.7.2-1.4.6-2,.4-.5,1-.8,1.7-.8.6,0,1.1.3,1.5.7.4.5.6,1.2.6,1.9,0,.7-.2,1.3-.5,1.9-.5.7-1.1,1.3-1.7,1.8-.8.7-1.6,1.5-2.2,2.4-.5.9-.8,1.9-.8,3v1.2c0,.2.2.4.4.4,0,0,0,0,0,0h4.3c.2,0,.4-.2.4-.4,0,0,0,0,0,0v-.8c0-.6.2-1.2.5-1.6.5-.6,1-1.1,1.6-1.6.6-.5,1.2-1,1.7-1.6.5-.6.8-1.2,1.1-1.9.3-.9.5-1.8.5-2.8.2-3.7-2.6-6.9-6.3-7.2-.3,0-.6,0-.9,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_292",
    className: "st1",
    d: "M27.9,35.7c-.8,0-1.5.3-2.1.8-.5.5-.8,1.3-.8,2.1,0,.8.3,1.5.8,2.1,1.2,1.1,3,1.1,4.2,0,.5-.6.8-1.3.8-2.1,0-.8-.3-1.5-.8-2.1-.6-.5-1.3-.8-2.1-.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_293",
    className: "st1",
    d: "M50.5,25.9l3.4-2.1-2.2-6.8-4,.3-2.9-4,1.5-3.7-5.8-4.2-3,2.6-4.7-1.5-.9-3.9h-7.2l-.9,3.9-4.7,1.5-3-2.6-5.8,4.2,1.5,3.7-2.9,4-4-.3-2.2,6.8,3.4,2.1v4.9l-3.4,2.1,2.2,6.8,4-.3,2.9,4-1.5,3.7,5.8,4.2,3-2.6,4.7,1.5.9,3.9h7.2l.9-3.9,4.7-1.5,3,2.6,5.8-4.2-1.5-3.7,2.9-4,4,.3,2.2-6.8-3.4-2.1v-4.9ZM40.2,40.9c-6.9,6.6-17.9,6.2-24.4-.7-6.6-6.9-6.2-17.9.7-24.4,6.9-6.6,17.9-6.2,24.4.7,3,3.2,4.7,7.5,4.7,11.9,0,4.8-2,9.3-5.4,12.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailContactPicto);
export default __webpack_public_path__ + "static/media/MailContactPicto.23d68a9a186612de02294cd6c8e0e849.svg";
export { ForwardRef as ReactComponent };